import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { addProtocol } from '../../utils/url';
import REPVISITS_CREATOR_TYPE from '../../utils/repvisits-creator-types';
import Input from '../../components/Input';
import messages from './messages';
import './styles.css';

const EventVisitUrl = ({
  visitUrl,
  visitUrlError,
  onVisitUrlChange,
  visitCreator,
}) => {
  const validUrl = visitUrl ? addProtocol(visitUrl).slice(0, 2048) : null;
  return (visitCreator === REPVISITS_CREATOR_TYPE.HIGH_SCHOOL) ? (
    <div
      data-cy="visit-url-input-container-read-only"
      styleName="visit-url-container"
    >
      <FormattedMessage {...messages.virtualVisitHint} />
      <a
        href={validUrl}
        styleName="virtual-visit-url"
        target="_blank"
        rel="noreferrer"
      >
        {validUrl}
      </a>
    </div>
  ) : (
    <div data-cy="visit-url-input-container" styleName="visit-url-container">
      <FormattedMessage {...messages.virtualVisitHint} />
      <Input
        data-cy="visit-url-input"
        styleName="visit-url-input"
        value={visitUrl}
        error={visitUrlError}
        onChange={onVisitUrlChange}
      />
    </div>
  );
};

EventVisitUrl.propTypes = {
  visitUrl: PropTypes.string,
  visitUrlError: PropTypes.bool,
  visitCreator: PropTypes.string,
  onVisitUrlChange: PropTypes.func.isRequired,
};

export default EventVisitUrl;
